module.exports = __webpack_public_path__ + "img/afzal.ef805640.jpg";